export default "__VITE_ASSET__BpAppUis__"